export default __webpack_public_path__ + "static/media/ps.2259eff8.svg";